import axios from "axios";

import type { Rating } from "@virtual-brain-lib/types";

import env from "../environments";

export async function createRating(data: Partial<Rating>) {
	const response = await axios.post<Rating>(env.apiUrl + "/ratings", data);

	return response.data;
}
